import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const SearchBar = ({ 
  placeholder = 'Search books...', 
  onSearch, 
  value = '', 
  className = '',
  showClear = true 
}) => {
  const { t } = useTranslation();
  const [searchTerm, setSearchTerm] = useState(value);

  useEffect(() => {
    setSearchTerm(value);
  }, [value]);

  const handleSearch = (term) => {
    setSearchTerm(term);
    if (onSearch) {
      onSearch(term);
    }
  };

  const handleClear = () => {
    setSearchTerm('');
    if (onSearch) {
      onSearch('');
    }
  };

  return (
    <div className={`search-bar ${className}`}>
        <div className="input-group">
        <span className="input-group-text border-end-0">
            <i className="fas fa-search text-muted"></i>
          </span>
          <input
            type="text"
            className="form-control border-start-0"
            placeholder={placeholder}
            value={searchTerm}
            onChange={(e) => handleSearch(e.target.value)}
            style={{
            borderRadius: showClear && searchTerm ? '0' : '0 8px 8px 0',
              border: '1px solid #dee2e6',
            borderLeft: 'none',
              backgroundColor: '#ffffff',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              fontSize: '0.95rem',
              padding: '0.75rem',
              transition: 'all 0.3s ease'
            }}
            onFocus={(e) => {
              e.target.style.borderColor = '#2c5530';
              e.target.style.boxShadow = '0 2px 8px rgba(44, 85, 48, 0.2)';
            }}
            onBlur={(e) => {
              e.target.style.borderColor = '#dee2e6';
              e.target.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
            }}
          />
          {showClear && searchTerm && (
            <button
              className="btn btn-outline-secondary border-start-0"
              onClick={handleClear}
              style={{
                borderRadius: '0 8px 8px 0',
                borderLeft: 'none',
                backgroundColor: '#ffffff',
                borderColor: '#dee2e6',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                padding: '0.75rem'
              }}
            >
              <i className="fas fa-times"></i>
            </button>
          )}
      </div>
    </div>
  );
};

export default SearchBar;
